import React from 'react';

import Autoplay from 'embla-carousel-autoplay';
import {Carousel} from 'presentation/components';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';

import {ContentCollectionListEnum} from 'domain/usecases/private/content/post-content';
import {useContentQuery} from 'presentation/queries/useContentQuery';
import {translations} from 'presentation/translations-new';
import {SectionContainer} from '../SectionContainer';
import {BlogBannerItem} from './components/BlogBannerItem';
import {BlogBannerLoading} from './components/BlogBannerLoading';
import {StyledBox} from './styles';

const {content} = translations['pt-br'].privateFlow.home;

export function BlogBanners() {
	const {isMobile, isLaptop} = useMediaQueries();
	const {
		dataHostNameState: {productCode},
	} = useHostName();

	const {
		data: banners,
		isError,
		isLoading,
	} = useContentQuery({
		lista_colection: [ContentCollectionListEnum.BLOG_HIGHLIGHT, ContentCollectionListEnum.BLOG],
		numero_item: 4,
		operadora: productCode[0].toString(),
	});

	if (isError) {
		return null;
	}

	if (isLoading) {
		return <BlogBannerLoading />;
	}

	const isEmpty = !banners || banners?.listaConteudos.length === 0;

	const isSingleItem = banners?.listaConteudos?.length === 1;

	return isEmpty ? null : (
		<SectionContainer
			title={content}
			titleMarginTop={0}
			titleMarginBottom={isLaptop ? 2 : '4px'}
			marginRight={isMobile ? '-16px' : undefined}
			showTitle>
			<StyledBox $isSingleItem={isSingleItem}>
				<Carousel
					hideButtons={isMobile}
					type={CarrouselTypeEnum.ARROWS_DOTS}
					plugins={[Autoplay({delay: 5000, stopOnInteraction: false})]}
					options={{dragFree: false, containScroll: 'trimSnaps'}}
					slides={banners?.listaConteudos.map(banner => (
						<BlogBannerItem
							key={banner.articleId}
							title={banner.campos.titulo ?? ''}
							description={banner.campos.descricao ?? ''}
							imageUrl={banner.campos.imagem ?? ''}
							imageAlt={banner.campos.imagem_alt ?? ''}
							linkUrl={banner.URL}
						/>
					))}
				/>
			</StyledBox>
		</SectionContainer>
	);
}
